import { render, staticRenderFns } from "./xfssTJ.vue?vue&type=template&id=838e58f0&scoped=true"
import script from "./xfssTJ.vue?vue&type=script&lang=js"
export * from "./xfssTJ.vue?vue&type=script&lang=js"
import style0 from "./xfssTJ.vue?vue&type=style&index=0&id=838e58f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838e58f0",
  null
  
)

export default component.exports